// extracted by mini-css-extract-plugin
module.exports = {"welcome-msg":"LoggedInBanner_welcome-msg__1FBUC","avatar":"LoggedInBanner_avatar__1sE1v"};